function getAliasOrNameFromObject(object) {
  if (object.alias) {
    return object.alias;
  }
  return object.name;
}

export default getAliasOrNameFromObject;
